// react
import React, { Component } from 'react';

// third-party
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// application
import departmentsAria from '../../services/departmentsArea';
import languages from '../../i18n';
import StroykaSlick from '../shared/StroykaSlick';

import shopApi from '../../api/shop';

const slickSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000
};


class BlockSlideShow extends Component {
    departmentsAreaRef = null;

    constructor(props) {
        super(props);
        this.state = {
            // slides: []
        }
    }

    media = window.matchMedia('(min-width: 992px)');


    slides = [
        {
            title: 'Big choice of<br>Plumbing products',
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br>Etiam pharetra laoreet dui quis molestie.',
            image_classic: {
                ltr: 'images/slides/slide-1-ltr.png',
                rtl: 'images/slides/slide-1-rtl.png',
            },
            image_full: {
                ltr: 'images/slides/slide-1-full-ltr.png',
                rtl: 'images/slides/slide-1-full-rtl.png',
            },
            image_mobile: {
                ltr: 'images/slides/slide-1-mobile.png',
                rtl: 'images/slides/slide-1-mobile.png',
            },
        },
        {
            title: 'Screwdrivers<br>Professional Tools',
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br>Etiam pharetra laoreet dui quis molestie.',
            image_classic: {
                ltr: 'images/slides/slide-2-ltr.png',
                rtl: 'images/slides/slide-2-rtl.png',
            },
            image_full: {
                ltr: 'images/slides/slide-2-full-ltr.png',
                rtl: 'images/slides/slide-2-full-rtl.png',
            },
            image_mobile: {
                ltr: 'images/slides/slide-2-mobile.png',
                rtl: 'images/slides/slide-2-mobile.png',
            },
        },
        {
            title: 'One more<br>Unique header',
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br>Etiam pharetra laoreet dui quis molestie.',
            image_classic: {
                ltr: 'images/slides/slide-3-ltr.png',
                rtl: 'images/slides/slide-3-rtl.png',
            },
            image_full: {
                ltr: 'images/slides/slide-3-full-ltr.png',
                rtl: 'images/slides/slide-3-full-rtl.png',
            },
            image_mobile: {
                ltr: 'images/slides/slide-3-mobile.png',
                rtl: 'images/slides/slide-3-mobile.png',
            },
        },
        {
            title: 'One more<br>Unique header',
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br>Etiam pharetra laoreet dui quis molestie.',
            image_classic: {
                ltr: 'images/slides/slide-4-ltr.png',
                rtl: 'images/slides/slide-4-rtl.png',
            },
            image_full: {
                ltr: 'images/slides/slide-4-full-ltr.png',
                rtl: 'images/slides/slide-4-full-rtl.png',
            },
            image_mobile: {
                ltr: 'images/slides/slide-4-mobile.png',
                rtl: 'images/slides/slide-4-mobile.png',
            },
        },
    ];

    componentDidMount() {
        if (this.media.addEventListener) {
            this.media.addEventListener('change', this.onChangeMedia);
        } else {
            this.media.addListener(this.onChangeMedia);
        }

        // var bannerTemp = [];
        // var tempObj = {}

        // var tempFull = {
        //     ltr: "",
        //     rtl: ""
        // }
        // var tempMid = {
        //     ltr: "",
        //     rtl: ""
        // }
        // var tempMobile = {
        //     ltr: "",
        //     rtl: ""
        // }

        // shopApi.getBanners({}).then(res => {
        //     for (let i = 0; i < res.data.length; i++) {

        //         if (res.data[i].Title.includes("full")) {
        //             // tempObj.title = res.data[i].Title
        //             // tempObj.text = res.data[i].Content
        //             tempFull.ltr = res.data[i].BannerImage
        //             tempFull.rtl = res.data[i].BannerImage
        //             // bannerTemp.push(tempObj)
        //             tempObj.image_full = tempMid

        //         }

        //         if (res.data[i].Title.includes("mid")) {
        //             // tempObj.title = res.data[i].Title
        //             // tempObj.text = res.data[i].Content
        //             tempMid.ltr = res.data[i].BannerImage
        //             tempMid.rtl = res.data[i].BannerImage
        //             // tempObj.tempMid
        //             tempObj.image_classic = tempMid

        //             // bannerTemp.push(tempObj)
        //         }

        //         if (res.data[i].Title.includes("mobile")) {
        //             tempMobile.ltr = res.data[i].BannerImage
        //             tempMobile.rtl = res.data[i].BannerImage
        //             tempObj.image_mobile = tempMobile

        //         }

        //         bannerTemp.push(tempObj)


        //         console.log("inner")


        //         // console.log(tempFull)
        //         // console.log(tempMid)
        //         // console.log(tempMobile)

        //     }

        //     console.log("bannerTemp")
        //     console.log(bannerTemp)

        //     this.setState({ slides: bannerTemp });

        // });



    }

    componentWillUnmount() {
        departmentsAria.area = null;

        if (this.media.removeEventListener) {
            this.media.removeEventListener('change', this.onChangeMedia);
        } else {
            // noinspection JSDeprecatedSymbols
            this.media.removeListener(this.onChangeMedia);
        }
    }

    onChangeMedia = () => {
        if (this.media.matches) {
            departmentsAria.area = this.departmentsAreaRef;
        }
    };

    setDepartmentsAreaRef = (ref) => {
        this.departmentsAreaRef = ref;

        if (this.media.matches) {
            departmentsAria.area = this.departmentsAreaRef;
        }
    };

    render() {
        const { locale, withDepartments } = this.props;
        const { direction } = languages[locale];

        const blockClasses = classNames(
            'block-slideshow block',
            {
                'block-slideshow--layout--full mt-0': !withDepartments,
                'block-slideshow--layout--with-departments': withDepartments,
            },
        );

        const layoutClasses = classNames(
            'col-12',
            {
                'col-lg-12 p-0': !withDepartments,
                'col-lg-9': withDepartments,
            },
        );
        const { slides } = this.state

        const slidesCons = this.slides.map((slide, index) => {
            const image = (withDepartments ? slide.image_classic : slide.image_full)[direction];

            return (
                <div key={index} className="block-slideshow__slide">
                    <div
                        className="block-slideshow__slide-image block-slideshow__slide-image--desktop custom-banner-div"
                        style={{
                            backgroundImage: `url(${image})`,
                        }}
                    />
                    <div
                        className="block-slideshow__slide-image block-slideshow__slide-image--mobile"
                        style={{
                            backgroundImage: `url(${slide.image_mobile[direction]})`,
                        }}
                    />
                    {/* <div className="block-slideshow__slide-content">
                        <div
                            className="block-slideshow__slide-title"
                            dangerouslySetInnerHTML={{ __html: slide.title }}
                        />
                        <div
                            className="block-slideshow__slide-text"
                            dangerouslySetInnerHTML={{ __html: slide.text }}
                        />
                    </div> */}
                </div>
            );
        });

        return (
            <div className={blockClasses}>
                <div className="container-fluid">
                    <div className="row">
                        {withDepartments && (
                            <div className="col-3 d-lg-block d-none" ref={this.setDepartmentsAreaRef} />
                        )}

                        <div className={layoutClasses}>
                            <div className="block-slideshow__body">
                                <StroykaSlick {...slickSettings}>
                                    {slidesCons}
                                </StroykaSlick>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BlockSlideShow.propTypes = {
    withDepartments: PropTypes.bool,
    /** current locale */
    locale: PropTypes.string,
};

BlockSlideShow.defaultProps = {
    withDepartments: false,
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(BlockSlideShow);
